module.exports = __webpack_public_path__ + "static/media/heart.8adef7a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heart.png
// module id = 293
// module chunks = 0